<template>
  <mdb-container fluid>
    <section class="section">
      <div class="row">
        <div class="col-lg-4">
          <mdb-card>
            <mdb-card-body>
              <div class="form-header blue accent-1 text-rigth">
                <b class="mt-2"
                  ><mdb-icon icon="envelope" /> شناسه اختصاصی :
                  <span v-text="ticketGroup.TicketId"></span>
                </b>
              </div>

              <div class="md-form">
                <mdb-input
                  label="عنوان"
                  type="text"
                      class="rtl"
                  :readOnly="true"
                  v-model="ticketGroup.Title"
                />
              </div>

              <div class="md-form">
                <mdb-input
                  label="آخرین بروزرسانی"
                  type="text"
                      class="rtl"
                  :readOnly="true"
                  v-model="ticketGroup.LastUpdate"
                />
              </div>

              <div class="md-form">
                <mdb-input
                  label="وضعیت"
                  type="text"
                      class="rtl"
                  :readOnly="true"
                  v-model="ticketGroup.StatusName"
                />
              </div>

              <div class="md-form">
                <mdb-input
                  label="دپارتمان"
                  type="text"
                      class="rtl"
                  :readOnly="true"
                  v-model="ticketGroup.DepartmentName"
                />
              </div>

              <div class="md-form">
                <mdb-input
                  label="اولیت"
                  type="text"
                      class="rtl"
                  :readOnly="true"
                  v-model="ticketGroup.LevelName"
                />
              </div>
            </mdb-card-body>
          </mdb-card>
        </div>

        <div class="col-lg-8 mt-lg-0 mt-5">
          <mdb-card>
            <mdb-card-body>
              <div class="p-4">
                <div
                  v-for="message in ticketGroup.Messages"
                  v-bind:key="message.Messages"
                  class=""
                >
                  <div class="text-center">
                    <small v-text="message.LastUpdate"></small>
                  </div>

                  <div v-if="message.IsFromMe" class="d-flex justify-content-end">
                    <div
                      class="primary-color rounded p-3 text-white w-75">
                      <p v-text="message.Body"></p>
                      <mdb-chip v-for="file in message.Files" 
                        v-bind:key="file.FileName" 
                        @clcikChip="download(file)"
                        color="lighten-4 mb-0"
                        >{{file.FileName}}</mdb-chip>

                    </div>
                  </div>

                  <div v-else class="d-flex justify-content-start media">
                    <!-- <img
                      class="mr-3 avatar-sm float-left"
                      src="https://mdbootstrap.com/img/Photos/Avatars/adach.jpg"
                    /> -->
                    <div class="avatar-sm float-left operator-avatar">
                      <div class="avatar-placeholder darken-3 blue">
                        <span v-text="message.FullName[0]"></span>
                      </div>
                      <span v-text="message.FullName"></span>&nbsp;
                      <span v-text="message.Side"></span>
                    </div>

                    <div class="grey lighten-3 rounded p-3 w-75">
                      <p v-html="message.Body"></p>

                      <mdb-chip v-for="file in message.Files" 
                        v-bind:key="file.FileName" 
                        @clcikChip="download(file)"
                        color="lighten-4 mb-0 blue"
                        >{{file.FileName}}</mdb-chip>

                    </div>
                    
                  </div>

                </div>

                <div class="row">
                  <hr class="col-11" />
                </div>
                <!-- New message -->
                <div class="row">
                  <div class="col-md-12">
                    <div class="d-flex flex-row">
                      
                      <div class="col-12 mt-2">
                        <mdb-progress v-if="posting"  class="my-3" :value="uploadProgress" striped animated></mdb-progress>
                      </div>
                    </div>

                    <div class="d-flex flex-row">                      
                      <div class="col-10">
                        <mdb-textarea
                          :rows="5"
                          class="chat-message-type rtl"
                          label="پیام شما"
                          v-model="body"
                        />
                        <mdb-chip v-for="file in files" 
                          v-bind:key="file.name" 
                          @closeChip="removeFile(file)"
                          color="lighten-4" close
                          >{{file.name}}</mdb-chip>
                      </div>

                      <div class="mt-5 col-2">

                        <mdb-file-input  floating lg icon="paperclip" multiple
                          @getValue="selectFile" btnColor="primary" class="attach" />
                        
                        <mdb-btn color="primary" 
                        :disabled="posting"
                        @click="sendMessage" size="lg">ارسال</mdb-btn>
                      </div>
                      
                    </div>
                   
                  </div>
                </div>

              </div>
            </mdb-card-body>
          </mdb-card>
        </div>
      </div>
    </section>
  </mdb-container>
</template>

<script>
import {
  mdbContainer,
  mdbBtn,
  mdbInput,
  mdbTextarea,
  mdbCard,
  mdbCardImage,
  mdbCardText,
  mdbCardBody,
  mdbIcon,
  mdbFileInput,
    mdbChip,
    mdbProgress ,
    mdbProgressBar
} from "mdbvue";

import crmApi from "@/api/crmApi";
import fileApi from "@/api/fileApi";

export default {
  name: "Chat",
  components: {
    mdbContainer,
    mdbBtn,
    mdbInput,
    mdbTextarea,
    mdbCard,
    mdbCardImage,
    mdbCardText,
    mdbCardBody,
    mdbIcon,
    mdbFileInput,
    mdbChip,
    mdbProgress ,
    mdbProgressBar
  },
  data() {
    return {
      ticketGroup: {},
      files: [],
      body: null,
      posting: false,
      uploadProgress: 0,

      allowedFormats: {
        
        // ویدیو
        "video/mp4": ".mp4",
        // تصاویر
        "image/bmp": ".bmp",
        "image/gif": ".gif",
        "image/jpeg": ".jpg",
        "image/png": ".png",
        "image/tiff": ".tiff",
        "image/x-icon": ".ico",
        "image/svg+xml": ".svg",
        "image/webp": ".webp",
        // اسناد
        "application/msword": ".doc",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ".docx",
        "application/pdf": ".pdf",
        "application/vnd.ms-powerpoint": ".ppt",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": ".pptx",
        "application/rtf": ".rtf",
        // اکسل
        "application/vnd.ms-excel": ".xls",
        "application/x-msexcel": ".xls",
        "application/ms-excel": ".xls",
        "application/msexcel": ".xls",
        "application/x-excel": ".xls",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx",
        // فایل‌های متنی
        "text/plain": ".txt",
        // فایل‌های فشرده (ZIP و RAR)
        "application/zip": ".zip",
        "application/zip-compressed": ".zip",
        "application/x-zip-compressed": ".zip",
        "multipart/x-zip": ".zip",
        "application/vnd.rar": ".rar",
        "application/octet-stream": ".rar",
        "application/x-rar-compressed": ".rar",
        "application/x-rar": ".rar",
        // فایل‌های صوتی
        "audio/mpeg": ".mp3",
        "audio/wav": ".wav",
        "audio/x-wav": ".wav",
      }
    };
  },
  methods: {
    selectFile(files) {
      if (files.length > 0) {
        // var fileList = this.files
        // this.files = [];
        
        for(var i = 0; i < files.length; i++){

          if (files[i]) {
            const mimeType = files[i].type;
            const extension = this.allowedFormats[mimeType];
            console.log(mimeType);
            if (extension) {
              // Optionally check if the file name matches the expected extension
              if (files[i].name.endsWith(extension)) {
                
                this.$toastr.s("پیوست "+files[i].name+" با موفقیت انتخاب شد.","پیوست فایل");
                this.files.push(files[i]);
              } else {
                
                this.$toastr.e("پیوست "+files[i].name+" دارای فرمت قابل قبول نیست.","پیوست فایل");
              }
            } else {
              
              this.$toastr.e("پیوست "+files[i].name+" دارای فرمت قابل قبول نیست.","پیوست فایل");
            }
          }

          }
        // this.files = files;
      } 
    },
    removeFile(rfile){ 
      var files = [];
      for(var i=0;i<this.files.length;i++){
        if(this.files[i].name!=rfile.name){          
          files.push(this.files[i])
        }
      }
      this.files = files;
    },
    sendMessage(){
      this.posting = true;

      let formData = new FormData();
      for(var i=0; i< this.files.length; i++){
        formData.append('Files', this.files[i]);
      }
      formData.append('Body', this.body);
      formData.append('TicketId', this.ticketGroup.TicketId);

      crmApi
        .sendTicketMessage(formData, (progressEvent) => {
        if (progressEvent.lengthComputable) {
          this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
      })
        .then(({ data }) => {
          if (data.Status === 1) {
            this.body = null;
            this.files = [];

            this.posting = false;
            this.$toastr.s("تیکت", "پیام شما با موفقیت ارسال شد.");
            // this.$store.dispatch(actionTypes.SAVE_DATA);
            crmApi.getTicket(this.ticketGroup.TicketId).then(
              ({ data }) => {
                this.ticketGroup = data;
              },
              (r) => {
                console.error(r);
              }
            );

          } else {
            this.message = data.Message;
            this.posting = false;
            // console.log(data);
            this.$toastr.e( data.Message,"تیکت");            
          }
        },
        (r) => {

          var message = r.response.data.errors;
          this.posting = false;
          this.message = null;

          if(message.hasOwnProperty("Body")){
            this.message = message.Body;
          }

          if(message.hasOwnProperty("Files")){
            this.message = message.CaptchaInputText;
          } 
          
          this.$toastr.e( "خطا در بارگذاری رخ داد. لطفاً فایل مناسب را انتخاب کنید.","ارسال تیکت");
        }
      );

    },
    download(file){      
      this.$toastr.w("دانلود", "فایل در حال دانلود است.");  
      // console.log('download file');
      fileApi
      .download(file.FileId).then((response) => {
        if (!window.navigator.msSaveOrOpenBlob){
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', file.FileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.$toastr.s("دانلود", "دانلود به پایان رسید.");  
        }else{
          // BLOB FOR EXPLORER 11
          const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]),file.FileName);
          this.$toastr.s("دانلود", "دانلود به پایان رسید.");  
        }
      },
        (r) => { 
          this.$toastr.e("دانلود", "خطا در دانلود فایل رخ داد.");
        }
      );
    }
  },
  mounted() {
    const vueThis = this;
    let ticketId = this.$route.params.ticketId;

    let ticketGroups = this.$store.state.ticketGroups;
    // console.log("type of", typeof ticketGroups);

    Array.from(ticketGroups).forEach((item) => {
      // console.log(item);
      if (item.TicketId == ticketId) {
        this.ticketGroup = item;
      }
    });

    crmApi.getTicket(ticketId).then(
      ({ data }) => {
        this.ticketGroup = data;
      },
      (r) => {
        console.error(r);
      }
    );
  },

};
</script>

<style scoped>
.avatar-sm {
  width: 56px;
  border-radius: 50%;
}
.chat-message-type {
  -webkit-box-flex: 1 !important;
  -webkit-flex: 1 0 auto !important;
  -ms-flex: 1 0 auto !important;
  flex: 1 0 auto !important;
}

.avatar-placeholder {
  height: 32px;
  color: rgba(255, 255, 255, 0.75);
  text-align: center;
  line-height: 32px;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: default;
}
.avatar-32,
.avatar-placeholder {
  width: 32px;
  margin-right: 8px;
  display: inline-block;
}
.avatar-32 {
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
.avatar-32,
.avatar-placeholder {
  width: 32px;
  margin-right: 8px;
  display: inline-block;
}


</style>
